'use client'
import { MktuClassButton, MktuClassPopup } from '@/shared/Mktu/components'
import { MktuClassStore } from '@/store/Mktu/MktuClass'
import cn from 'classnames'
import { FC, FunctionComponent, useCallback, useMemo, useState } from 'react'
import styles from './MktuClasses.module.scss'
import { MktuClass, MktuClassWord } from '@/services/Api/generated'
import { observer } from 'mobx-react-lite'

type MktuClassesProps = {
  className?: string
  productClass: MktuClassStore[]
  servicesClass: MktuClassStore[]
  selectedClasses?: MktuClassStore[]
  selectClass: (mktuClassStore: MktuClassStore) => void
}
export const MktuClasses: FunctionComponent<MktuClassesProps> = observer(
  ({
    className,
    productClass,
    servicesClass,
    selectedClasses = [],
    selectClass,
  }) => {
    return (
      <div className={cn(className, styles.container)}>
        <div className={styles.description}>
          Справочник МКТУ
          <div className={styles.descriptionSmall}>
            (редакция № 12 от 2025 г.)
          </div>
        </div>

        <div className={styles.group}>
          <div className={styles.groupTitle}>Товары:</div>
          <div className={styles.groupList}>
            {productClass.map((mktuClass) => (
              <Item
                key={mktuClass.number}
                mktuClass={mktuClass}
                selectedClasses={selectedClasses}
                onSelect={selectClass}
              />
            ))}
          </div>
        </div>
        <div className={styles.group}>
          <div className={styles.groupTitle}>Услуги:</div>
          <div className={styles.groupList}>
            {servicesClass.map((mktuClass) => (
              <Item
                key={mktuClass.number}
                mktuClass={mktuClass}
                selectedClasses={selectedClasses}
                onSelect={selectClass}
              />
            ))}
          </div>
        </div>
      </div>
    )
  }
)

interface ItemProps {
  mktuClass: MktuClassStore
  selectedClasses: MktuClassStore[]
  onSelect(mktuClass: MktuClassStore): void
}
const Item: FC<ItemProps> = ({ mktuClass, selectedClasses, onSelect }) => {
  const [isVisible, setIsVisible] = useState(false)

  const show = useCallback(() => {
    setIsVisible(true)
  }, [])

  const hide = useCallback(() => {
    setIsVisible(false)
  }, [])

  const isSelected = useMemo(() => {
    return (
      selectedClasses.find(
        (c) => c.number === mktuClass.mktuClass.classNumber
      ) != null
    )
  }, [mktuClass.mktuClass.classNumber, selectedClasses])

  const applyWords = useCallback(
    (words: Array<MktuClassWord['word']>) => {
      const selectedClass = selectedClasses.find(
        (c) => c.number === mktuClass.mktuClass.classNumber
      )
      if (selectedClass != null) {
        selectedClass.setSelectedWordsNames(words)
      } else {
        const newMktuClassStore = new MktuClassStore(
          { ...mktuClass.mktuClass },
          mktuClass.words
        )
        newMktuClassStore.setSelectedWordsNames(words)
        onSelect(newMktuClassStore)
      }
      hide()
    },
    [hide, mktuClass, onSelect, selectedClasses]
  )

  return (
    <>
      <MktuClassButton
        className={styles.mktuClassButton}
        classNumber={mktuClass.number}
        isSelected={isSelected}
        onClick={show}
      />
      {isVisible ? (
        <MktuClassPopup
          onClose={hide}
          onApplyWords={applyWords}
          withDescriptionClass={false}
          mktuClass={mktuClass}
        />
      ) : null}
    </>
  )
}
